import { GridRow } from '@mui/x-data-grid';
import type { CustomerOverview } from '@weft/api-definition';
import { VyIcon } from '@weft/icons';
import { withDefault } from '@weft/utils';
import React from 'react';
import { NavLink } from 'react-router-dom';
import type { VyTableMinimalProps } from '../../../../components/new-design/table/vy-table/VyTable';
import { VyTable } from '../../../../components/new-design/table/vy-table/VyTable';
import { VyTableToolbar } from '../../../../components/new-design/table/vy-table-toolbar/vy-table-toolbar';
import { useSearchWithSearchParams } from '../../../../hooks/use-search-with-search-params';
import { CUSTOMERS_COLUMNS } from '../customers-page-consts/customers-columns';

export const CustomersTable: React.FC<VyTableMinimalProps<CustomerOverview>> = ({ items, itemsCount, loadingItems }) => {
  const [customersQuery, setCustomersSearch] = useSearchWithSearchParams();

  return (
    <>
      <VyTableToolbar>
        <VyTableToolbar.Queries>
          <VyTableToolbar.SearchInput
            onChange={(event) => setCustomersSearch(event.target.value)}
            defaultValue={withDefault(customersQuery, '')}
          />
        </VyTableToolbar.Queries>

        <VyTableToolbar.Actions>
          <VyTableToolbar.CtaButton
            sx={{ columnGap: '12px' }}
            component={NavLink}
            to="create"
          >
            <VyIcon icon="PlusMedium"/>
            Customer
          </VyTableToolbar.CtaButton>
        </VyTableToolbar.Actions>
      </VyTableToolbar>

      <VyTable
        itemsCount={itemsCount}
        items={items}
        columns={CUSTOMERS_COLUMNS}
        loadingItems={loadingItems}
        sx={{
          paddingBottom: '160px',
        }}
        slots={{
          row: (rowProps) => {
            const { id } = rowProps.row;

            return (
              <NavLink
                onClick={(event: React.MouseEvent<HTMLAnchorElement> & { ignore?: boolean }) => {
                  if (event.ignore) {
                    event.preventDefault();
                  }
                }}
                to={`/customers/${id}/realtime-activity`}
              >
                <GridRow {...rowProps} />
              </NavLink>
            );
          },
        }}
      />
    </>
  );
};